import { NgModule, Component } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { RecruiterListComponent } from "./recruiter-list/recruiter-list.component";
import { RecruiterCreateComponent } from "./recruiter-create/recruiter-create.component";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "list-recruiter",
        component: RecruiterListComponent,
        data: {
          title: "List Recruiter",
          breadcrumb: "List Recruiter",
        },
      },
      {
        path: "create-recruiter",
        component: RecruiterCreateComponent,
        data: {
          title: "Create Recruiter",
          breadcrumb: "Create Recruiter",
        },
      },
      {
        path: "create-recruiter/:id",
        component: RecruiterCreateComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RecruiterRoutingModule {}
